<template>
  <div class="lottie">
    <div ref="lottieIcon" class="lottie-content"></div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.lottie = lottie.loadAnimation({
      container: this.$refs.lottieIcon, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: this.url // the path to the animation json
    })
    this.lottie.addEventListener('loopComplete', () => {
      this.lottie.playSegments([0, 8], true)
    })
  },
  methods: {
    draw() {
      this.lottie.playSegments([0, 8], true)
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 1000)
      })
    },
    result() {
      this.lottie.playSegments([0, 12], true)
      this.lottie.goToAndPlay(800)
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 300)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.lottie-content {
  width: 100%;
  height: 100%;
}
</style>
